<template>
  <div>
    <template v-if="type !== 'double'">
      <div class="progress-chart-wrapper">
        <div class="value-wrapper">
          <span>{{ percent }}%</span>
        </div>
        <svg
          class="p-progress-chart"
          width="200"
          height="200"
          viewBox="0 0 120 120"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            r="45%"
            cx="50%"
            cy="50%"
            fill="transparent"
            :class="circleClass"
            :stroke-dasharray="strokeDasharray"
            stroke-dashoffset="0"
          />
          <circle
            ref="single_bar"
            class="bar"
            r="45%"
            cx="50%"
            cy="50%"
            fill="transparent"
            stroke="#EFF2F7"
            :stroke-dasharray="strokeDasharray"
            stroke-dashoffset="0"
          />
        </svg>
      </div>
    </template>
    <template v-else>
      <div class="progress-chart-wrapper progress-chart__double">
        <div class="value-wrapper">
          <span>{{ successPercent }}%</span>
        </div>
        <div class="progress_wrapper">
          <svg
            class="p-progress-chart p-progress-chart_failed"
            width="200"
            height="200"
            viewBox="0 0 120 120"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              r="45%"
              cx="50%"
              cy="50%"
              fill="transparent"
              class="failed"
              :stroke-dasharray="strokeDasharray"
              stroke-dashoffset="0"
            />
            <circle
              ref="failed_bar"
              :data-percent="failurePercent"
              class="bar"
              r="45%"
              cx="50%"
              cy="50%"
              fill="transparent"
              stroke="#EFF2F7"
              :stroke-dasharray="strokeDasharray"
              stroke-dashoffset="0"
            />
          </svg>
          <svg
            class="p-progress-chart p-progress-chart_success"
            width="155"
            height="155"
            viewBox="0 0 120 120"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              r="45%"
              cx="50%"
              cy="50%"
              fill="transparent"
              class="success"
              :stroke-dasharray="strokeDasharray"
              stroke-dashoffset="0"
            />
            <circle
              ref="success_bar"
              class="bar"
              r="45%"
              cx="50%"
              cy="50%"
              fill="transparent"
              stroke="#EFF2F7"
              :stroke-dasharray="strokeDasharray"
              stroke-dashoffset="0"
            />
          </svg>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
/* eslint-disable prefer-destructuring */
import theme from '@/mixins/theme';

export default {
  mixins: [theme],
  name: 'ProgressChart',
  data() {
    return {
      strokeDasharray: '339.5',
      circleClass: '',
    };
  },
  props: {
    /**
     * The type of the progressChart
     * @values success, failed, double
     * @default is success
     * */
    type: {
      type: String,
      required: true,
      default: 'success',
      validator: value => ['success', 'failed', 'double'].indexOf(value) !== -1,
    },
    /**
     * The percentage of the progressChart, if type is success or failed
     * @values Numbers between 1 -100
     * @default is 0
     * */
    percent: {
      type: Number,
      default: 0,
      validator: value => [...Array(101).keys()].indexOf(value) !== -1,
    },
    /**
     * The success percentage of the progressChart, if type is double
     * @values Numbers between 1 -100
     * @default is 0
     * */
    successPercent: {
      type: Number,
      default: 0,
      validator: value => [...Array(101).keys()].indexOf(value) !== -1,
    },
    /**
     * The failed percentage of the progressChart, if type is double
     * @values Numbers between 1 -100
     * @default is 0
     * */
    failurePercent: {
      type: Number,
      default: 0,
      validator: value => [...Array(101).keys()].indexOf(value) !== -1,
    },
  },
  // computed: {

  // },
  mounted() {
    setTimeout(() => {
      this.mountChart(this.percent, this.successPercent, this.failurePercent);
    }, 400);
    this.getColor();
  },
  methods: {
    mountChart(
      percent = 0,
      successPercent = 0,
      failurePercent = 0,
      animated = true,
    ) {
      if (this.type === 'success' || this.type === 'failed') {
        if (animated) {
          this.$refs.single_bar.style.transition = 'stroke-dashoffset 1s ease';
        } else {
          this.$refs.single_bar.style.transition = '';
        }
        this.$refs.single_bar.style['stroke-dashoffset'] =
          (this.strokeDasharray * Number(percent)) / 100;
      } else if (this.type === 'double') {
        if (animated) {
          this.$refs.success_bar.style.transition = 'stroke-dashoffset 1s ease';
          this.$refs.failed_bar.style.transition = 'stroke-dashoffset 1s ease';
        } else {
          this.$refs.success_bar.style.transition = '';
          this.$refs.failed_bar.style.transition = '';
        }
        this.$refs.success_bar.style['stroke-dashoffset'] =
          (this.strokeDasharray * Number(successPercent)) / 100;
        this.$refs.failed_bar.style['stroke-dashoffset'] =
          (this.strokeDasharray * Number(failurePercent)) / 100;
      }
    },
    getColor() {
      if (this.type === 'success') {
        this.circleClass = 'success';
      } else if (this.type === 'failed') {
        this.circleClass = 'failed';
      }
    },
  },

  updated() {
    this.$nextTick(() => {
      this.mountChart(0, 0, 0, false);
      setTimeout(() => {
        this.mountChart(this.percent, this.successPercent, this.failurePercent);
      }, 400);
    });
    this.getColor();
  },
};
</script>

<style scoped lang="scss">
@import 'progress-chart';
</style>
